import React, { createContext, useState, useCallback, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';
import Qs from 'query-string';
import '../../constants/login.js';
import '../../constants/activity.js';
import '../../constants/common.js';
import { specialInnerCodeMap } from '../../constants/specialInnerCode.js';
import { triggerLinkClick } from '../../utils/triggerLinkClick.js';
import { isEmpty } from '../../utils/isEmpty.js';
import 'validator';
import '../../utils/serverTime.js';
import 'crypto-js/sha256';
import 'crypto-js/enc-base64';
import 'crypto-js/hmac-sha256';
import '../../utils/rbacErrorHandler.js';
import { RbacLoginChoices } from '../useRbacLoginInfo/index.js';

/*
 * @Author: yuchen
 * @Date: 2021-03-26 13:50:55
 * @LastEditTime: 2023-08-21 19:15:14
 * @LastEditors: yuchen
 * @Description: 用于方便获取 OPENAPI 和 URS 的登录信息 (需要配合项目中已经存在相关的后端代理配置使用)
 */
const LoginInfoContext = createContext(null);
// eslint-disable-next-line react-func/max-lines-per-function
const LoginInfoContextProvider = (props) => {
    const { isUrs4login = true, customUserInfoUrl, getCustomUserInfoHeaders = () => { }, rbacUrl, autoFetchInfoWhenTokenNotExisted = false, beforeGettingHook, afterGettingHook, beforeGettingHookErrorCb, cookieDomain, customNoAuthRedirectUrl = '', customNoAuthCodeList = [401, 403], customNoAuthFullCodeList = [
        specialInnerCodeMap['loginUnAuth'],
        specialInnerCodeMap['loginTokenExpired'],
        specialInnerCodeMap['loginPermissionDenied'],
        specialInnerCodeMap['loginTokenNotFoundUser'],
    ], autoNoAuthRedirect = true, getTmpTokenUrl, getTmpTokenUrlHeaders = () => { }, ...rest } = props;
    const [ursloginUrl] = useState(isUrs4login ? '/urs4login' : '/urslogin');
    const [isLogin, setIsLogin] = useState(false);
    const [isGettingRbacUserInfo, setIsGettingRbacUserInfo] = useState(false);
    const [rbacUserInfo, setRbacUserInfo] = useState({});
    const [noAuth, setNoAuth] = useState(false);
    const loginByOpenApi = (next) => {
        triggerLinkClick(`${rbacUrl ? `${rbacUrl}/login` : RbacLoginChoices.OpenAPI}?next=${next ? encodeURI(next) : window?.location.href}`);
    };
    const loginByUrs = (next) => {
        triggerLinkClick(`${rbacUrl ? rbacUrl : '/rbac'}${ursloginUrl}?next=${next ? encodeURI(next) : window?.location.href}`);
    };
    const loginByWeChat = (options) => {
        const { next, server } = Object.assign({ next: window?.location.href }, options);
        window.location.href = `${rbacUrl ? `${rbacUrl}/wxlogin` : RbacLoginChoices.WeChat}?${Qs.stringify({
            next,
            server,
        })}`;
    };
    const loginByWeChatMobile = ({ wxAppId, redirect_uri, wxScope = 'snsapi_userinfo', }) => {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppId}&redirect_uri=${encodeURI(`${redirect_uri}`)}&response_type=code&scope=${wxScope}#wechat_redirect`;
    };
    const handleEmptyAll = () => {
        setIsLogin(false);
        setRbacUserInfo({});
    };
    // 具体的 redirect 逻辑可以根据项目自己的需求自行添加，该函数只用于登录状态的改变和 Cookie 的清除，对于一些特殊情况 domain 可以自己手动清除
    const handleLogOut = () => {
        // 确保手动设置的 cookie 可以被清除
        Cookies.remove('RBAC_TOKEN');
        Cookies.remove('RBAC_USER');
        Cookies.remove('RBAC_TOKEN', { path: '/', domain: '.netease.com' });
        Cookies.remove('RBAC_USER', { path: '/', domain: '.netease.com' });
        Cookies.remove('RBAC_TOKEN', { path: '/', domain: '.danlu.netease.com' });
        Cookies.remove('RBAC_USER', { path: '/', domain: '.danlu.netease.com' });
        Cookies.remove('RBAC_TOKEN', { path: '/', domain: '.fuxi.netease.com' });
        Cookies.remove('RBAC_USER', { path: '/', domain: '.fuxi.netease.com' });
        Cookies.remove('P_INFO', { path: '/', domain: '.netease.com' });
        Cookies.remove('S_INFO', { path: '/', domain: '.netease.com' });
        if (cookieDomain) {
            Cookies.remove('RBAC_TOKEN', { path: '/', domain: cookieDomain });
            Cookies.remove('RBAC_USER', { path: '/', domain: cookieDomain });
        }
        handleEmptyAll();
    };
    // 在跨域的时候 rbac 将信息拼接到 url，前端手动写入 cookie
    // eslint-disable-next-line react-func/max-lines-per-function
    async function handleCookieSetting(callback) {
        const { RBAC_TOKEN: PATH_RBAC_TOKEN, RBAC_USER: PATH_RBAC_USER, tmp_token, ...restQuery } = Qs.parse(window?.location.search || '');
        let RBAC_TOKEN = PATH_RBAC_TOKEN, RBAC_USER = PATH_RBAC_USER;
        if (tmp_token && getTmpTokenUrl) {
            // 免密登录新增逻辑：如果url中存在tmp_token字段，先请求瑶台后端拿到RBAC_TOKEN & RBAC_USER，再做之后的逻辑
            try {
                const response = await window?.fetch(getTmpTokenUrl, {
                    method: 'POST',
                    headers: getTmpTokenUrlHeaders(),
                    body: JSON.stringify({ tmp_token }),
                });
                const data = await response.json();
                RBAC_TOKEN = data.data.RBAC_TOKEN;
                RBAC_USER = data.data.RBAC_USER;
            }
            catch (error) {
                handleEmptyAll();
                return Promise.reject(error);
            }
        }
        if (RBAC_USER && RBAC_TOKEN) {
            Cookies.get('RBAC_TOKEN') && handleLogOut();
            Cookies.set('RBAC_USER', RBAC_USER, { domain: cookieDomain, path: '/', expires: 1 });
            Cookies.set('RBAC_TOKEN', RBAC_TOKEN, { domain: cookieDomain, path: '/', expires: 1 });
            // eslint-disable-next-line max-depth
            if (!isEmpty(restQuery)) {
                window.history.replaceState(null, '', `${window.location.pathname}?${Qs.stringify(restQuery)}${window.location.hash}`);
            }
            else {
                window.history.replaceState(null, '', `${window.location.pathname}${window.location.hash}`);
            }
            callback?.();
        }
    }
    // eslint-disable-next-line react-func/max-lines-per-function
    const handleFetchLoginInfo = useCallback(() => {
        setIsGettingRbacUserInfo(true);
        window
            ?.fetch(customUserInfoUrl || '/rbac/api/v1/web/users', { headers: getCustomUserInfoHeaders() })
            .then(response => response.json())
            .then(data => {
            // rbac 获取信息报错，最常见的为 token 校验失败
            if (customNoAuthCodeList.includes(+String(data?.code || '').slice(0, 3)) ||
                customNoAuthFullCodeList.includes(+String(data?.code || ''))) {
                setNoAuth(true);
                if (autoNoAuthRedirect) {
                    handleLogOut();
                    // eslint-disable-next-line max-depth
                    window.location.href = customNoAuthRedirectUrl || `/rbac/login?next=${window.location.href}`;
                }
            }
            else if (!data || data.code) {
                handleEmptyAll();
            }
            else {
                setIsLogin(true);
                setRbacUserInfo(data);
                afterGettingHook?.(data);
            }
        })
            .catch(err => {
            handleEmptyAll();
        })
            .finally(() => {
            setIsGettingRbacUserInfo(false);
        });
    }, [customUserInfoUrl, customNoAuthRedirectUrl, JSON.stringify(customNoAuthCodeList)]);
    // eslint-disable-next-line react-func/max-lines-per-function
    const handleGetRbacInfo = useCallback(async () => {
        try {
            await handleCookieSetting();
            if (autoFetchInfoWhenTokenNotExisted || Cookies.get('RBAC_TOKEN')) {
                // eslint-disable-next-line max-depth
                if (beforeGettingHook) {
                    await beforeGettingHook();
                }
                handleFetchLoginInfo();
            }
        }
        catch (error) {
            beforeGettingHookErrorCb?.();
            handleLogOut();
        }
    }, [autoFetchInfoWhenTokenNotExisted, beforeGettingHook, beforeGettingHookErrorCb, handleFetchLoginInfo]);
    // eslint-disable-next-line react-func/max-lines-per-function
    useEffect(() => {
        handleGetRbacInfo();
    }, [handleGetRbacInfo]);
    useEffect(() => {
        if (!Cookies.get('RBAC_TOKEN')) {
            setIsLogin(false);
        }
    }, []);
    return (React.createElement(LoginInfoContext.Provider, { value: {
            isLogin,
            isGettingRbacUserInfo,
            rbacUserInfo,
            handleLogOut,
            loginByOpenApi,
            loginByUrs,
            loginByWeChat,
            loginByWeChatMobile,
            handleFetchLoginInfo,
            hasUserInfo: !isEmpty(rbacUserInfo),
            hasToken: !!Cookies.get('RBAC_TOKEN'),
            noAuth,
        }, ...rest }));
};
// 登录相关 Cookie 的写入代理配置到 rbac 提供的相关路由即可
function useLoginInfo() {
    const context = useContext(LoginInfoContext);
    if (!context) {
        throw new Error(`请在组件外使用 LoginInfoContextProvider`);
    }
    //NOTE: createContext 不支持嵌套泛型传入这里使用双重断言
    return context;
}

export { LoginInfoContextProvider, useLoginInfo as default, useLoginInfo };
